import { Volume2, VolumeX } from 'lucide-react'
import { feedback, primeAudio, useSettings } from '../lib/feedback'
import { IconButton } from './ui'

/** Mute switch: icon-only in the header, a full row (icon + text) inside the menu sheet. */
export function SoundToggle({ withLabel = false }: { withLabel?: boolean }) {
  const sound = useSettings((s) => s.sound)
  const toggleSound = useSettings((s) => s.toggleSound)
  const onToggle = () => {
    primeAudio()
    toggleSound()
    if (!sound) feedback('react')
  }
  const label = sound ? 'Mute sounds' : 'Unmute sounds'
  const Icon = sound ? Volume2 : VolumeX

  if (withLabel) {
    return (
      <button
        type="button"
        onClick={onToggle}
        aria-pressed={sound}
        className="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm font-medium hover:bg-slate-100 dark:hover:bg-slate-800"
      >
        <Icon className="size-5 text-slate-500" aria-hidden />
        <span className="flex-1">{sound ? 'Sounds on' : 'Sounds off'}</span>
        <span className="text-xs text-slate-500">{sound ? 'tap to mute' : 'tap to unmute'}</span>
      </button>
    )
  }
  return (
    <IconButton label={label} onClick={onToggle} aria-pressed={sound} className="size-9">
      <Icon className="size-4" aria-hidden />
    </IconButton>
  )
}
